import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { immerable } from 'immer';
import GridNode from './GridNode';
import { DEFAULT_BREAKPOINT_NAME, GRID_NODE_TYPES } from './constants';
import { convertMapOfAvroToMapOfJson, mergeIntoPath } from './utils';
import { ModuleTypename } from '../../__generated__/chirp/com/hubspot/content/grid/layouts/rpc/GridLayoutsRpc';
export default class ModuleNode extends GridNode {
  constructor(_ref) {
    let moduleNodeParams = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
    super(moduleNodeParams);
    this[immerable] = true;
  }
  cloneAndChange(moduleNodeParams) {
    const {
      id,
      parentNodeId,
      value,
      treeRef
    } = moduleNodeParams;
    const newNodeParams = {
      id: id !== null && id !== void 0 ? id : this._id,
      type: GRID_NODE_TYPES.MODULE,
      treeRef: treeRef !== null && treeRef !== void 0 ? treeRef : this._treeRef,
      parentNodeId: parentNodeId !== null && parentNodeId !== void 0 ? parentNodeId : this._parentNodeId,
      value: value !== null && value !== void 0 ? value : this._value
    };
    return newNodeParams.treeRef.createNewModule(newNodeParams);
  }
  serializeNode(__options) {
    return Object.assign({}, this.getValue(), {
      __typename: ModuleTypename
    });
  }
  exportNode() {
    return {
      id: this.getId(),
      value: this.getValue(),
      parentNodeId: this.getParentNodeId(),
      childNodeIds: undefined
    };
  }
  mergeIntoValue(partialValue, path) {
    return this.cloneAndChange({
      value: mergeIntoPath(this._value, partialValue, path)
    });
  }
  mergeIntoStylesByPath(partialStyles, path) {
    return this.cloneAndChange({
      value: Object.assign({}, this._value, {
        styles: mergeIntoPath(this.getStyles(), partialStyles, path)
      })
    });
  }
  mergeIntoEditorProvidedStyles(partialStyles) {
    return this.cloneAndChange({
      value: Object.assign({}, this._value, {
        styles: mergeIntoPath(this.getStyles(), partialStyles, ['editorProvidedModuleBreakpointStyles', 'breakpointStyles'])
      })
    });
  }
  mergeIntoStyleFields(partialStyles) {
    return this.cloneAndChange({
      value: Object.assign({}, this._value, {
        styles: mergeIntoPath(this.getStyles(), partialStyles, ['styleFieldsModuleBreakpointStyles', 'breakpointStyles'])
      })
    });
  }
  mergeIntoOldModuleStyles(partialStyles) {
    return this.cloneAndChange({
      value: Object.assign({}, this._value, {
        styles: mergeIntoPath(this.getStyles(), {
          oldModuleStyles: partialStyles
        }, ['oldModuleStyles'])
      })
    });
  }
  getEditorProvidedBreakpointStyles(breakpoint = 'default') {
    const editorProvidedBreakpointStyles = this.getStyles().editorProvidedModuleBreakpointStyles;
    if (editorProvidedBreakpointStyles) {
      const defaultStyles = Object.assign({}, editorProvidedBreakpointStyles.breakpointStyles.default);
      if (breakpoint !== 'default') {
        return Object.assign({}, defaultStyles, editorProvidedBreakpointStyles.breakpointStyles[breakpoint]);
      }
      return defaultStyles;
    }
    return {};
  }
  getStyles() {
    return this.getValue().styles;
  }
  getEffectiveEditorProvidedStyle(style, breakpoint, breakpointsByInheritance) {
    var _this$getStyles$edito, _editorProvidedBreakp;
    const editorProvidedBreakpointStyles = ((_this$getStyles$edito = this.getStyles().editorProvidedModuleBreakpointStyles) === null || _this$getStyles$edito === void 0 ? void 0 : _this$getStyles$edito.breakpointStyles) || {
      default: {}
    };
    const styleAtBreakpoint = (_editorProvidedBreakp = editorProvidedBreakpointStyles[breakpoint]) === null || _editorProvidedBreakp === void 0 ? void 0 : _editorProvidedBreakp[style];
    if (styleAtBreakpoint !== undefined) {
      return {
        value: styleAtBreakpoint,
        inheritedBy: breakpoint
      };
    }
    const parentBreakpoint = breakpointsByInheritance[breakpoint];
    if (parentBreakpoint === undefined) {
      var _editorProvidedBreakp2;
      return {
        value: (_editorProvidedBreakp2 = editorProvidedBreakpointStyles[DEFAULT_BREAKPOINT_NAME]) === null || _editorProvidedBreakp2 === void 0 ? void 0 : _editorProvidedBreakp2[style],
        inheritedBy: DEFAULT_BREAKPOINT_NAME
      };
    }
    return this.getEffectiveEditorProvidedStyle(style, parentBreakpoint, breakpointsByInheritance);
  }
  getFieldOverrides() {
    return convertMapOfAvroToMapOfJson(this.getValue().fieldOverrides);
  }
  getLabel() {
    var _this$getValue$label;
    return (_this$getValue$label = this.getValue().label) !== null && _this$getValue$label !== void 0 ? _this$getValue$label : '';
  }
  getAllDescendantNodeIds() {
    return [];
  }
  getParentNode() {
    if (this.hasParentNode()) {
      return this.getTree().findContainer(this._parentNodeId);
    }
    throw new Error('Node has no parent node');
  }
}